import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const tabs = ["Assessment 1", "Assessment 2", "Assessment 3", "Assessment 4"];

// Words have no numeric order — rank by class sequence, not alphabet.
const CLASS_RANK = {
  nursery: 0,
  nur: 0,
  lkg: 1,
  ukg: 2,
  class1: 3,
  classi: 3,
  class2: 4,
  classii: 4,
};

function classRank(label) {
  const key = String(label).toLowerCase().replace(/[^a-z0-9]/g, "");
  return CLASS_RANK[key] ?? 99;
}

function sortByClass(items) {
  return [...items].sort((a, b) => classRank(a.classLabel) - classRank(b.classLabel));
}

const syllabusByTab = {
  "Assessment 1": [
    {
      classLabel: "Nursery",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Foundational_Stage/assessment_1/Class_NURSERY_assessment_1.pdf",
    },
    {
      classLabel: "Nursery",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Foundational_Stage/assessment_1/Class_NURSERY_assessment_1.pdf",
    },
  ],
  "Assessment 2": [
    {
      classLabel: "LKG",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Foundational_Stage/assessment_2/Assessment_2_LKG_Syllabus.pdf",
    },
    {
      classLabel: "UKG",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Foundational_Stage/assessment_2/Assessment_2_UKG_Syllabus.pdf",
    },
    {
      classLabel: "Class 1",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Foundational_Stage/assessment_2/Assessment_2_Syllabus_Class 1 .pdf",
    },
    {
      classLabel: "Class 2",
      fileName:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/syllabus/Foundational_Stage/assessment_2/Assessment_2_Syllabus_Class_2.pdf",
    },
  ],
  "Assessment 3": [],
  "Assessment 4": [],
};

function pdfHref(fileName) {
  return encodeURI(`${fileName}`);
}

function FoundationalStage() {
  const [tab, setTab] = useState("Assessment 1");
  const syllabusItems = sortByClass(syllabusByTab[tab] || []);

  useEffect(() => {
    document.title =
      "Foundational Stage (Nur to II) - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Syllabus</li>
          <li>Foundational Stage (Nur to II)</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="fw-bold">Foundational Stage (Nur to II)</h1>
            </div>
          </div>

          <nav>
            <div className="nav nav-tabs" role="tablist">
              {tabs.map((name) => (
                <button
                  key={name}
                  type="button"
                  role="tab"
                  className={`nav-link${tab === name ? " active" : ""}`}
                  aria-selected={tab === name}
                  onClick={() => setTab(name)}
                >
                  {name}
                </button>
              ))}
            </div>
          </nav>

          <div className="row mt-4">
            {syllabusItems.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.fileName}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{item.classLabel}</h6>
                    <a
                      href={pdfHref(item.fileName)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FoundationalStage;
